export type ThemePreference = 'system' | 'light' | 'dark'

const STORAGE_KEY = 'theme_preference'

function isThemePreference(value: unknown): value is ThemePreference {
  return value === 'system' || value === 'light' || value === 'dark'
}

export function getStoredThemePreference(): ThemePreference {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (isThemePreference(raw)) return raw
  } catch {
    // ignore
  }
  return 'system'
}

export function setStoredThemePreference(preference: ThemePreference): void {
  try {
    localStorage.setItem(STORAGE_KEY, preference)
  } catch {
    // ignore
  }
}

export function applyThemePreference(preference: ThemePreference): void {
  const root = document.documentElement

  if (preference === 'system') {
    root.removeAttribute('data-theme')
    return
  }

  root.setAttribute('data-theme', preference)
}

export function initThemePreference(): ThemePreference {
  const preference = getStoredThemePreference()
  applyThemePreference(preference)
  return preference
}
